import { useState, useRef, useEffect } from "react";
import { Image, Header, Placeholder, Button } from "semantic-ui-react";

export default function CompetitionsCards(props) {
    const imgRef = useRef(null);
    const [state, setState] = useState(false);

    const onImageLoaded = () => setState(true);

    useEffect(() => {
        const imgElCurrent = imgRef.current;

        if (imgElCurrent) {
            imgElCurrent.addEventListener("load", onImageLoaded);
            return () => imgElCurrent.removeEventListener("load", onImageLoaded);
        }
    }, [imgRef]);

    const { name, photo, details, rules, submit, setShow, setContent, modal , btnVisibilty,submitAlt } = props;
    return (
        <div  className={"competition-details-card"}>
        
            <Placeholder className={"competition-photo"} style={{ display: state ? "none" : "block" }}>
                {/*<Placeholder.Image*/}
                {/*    as={"img"}*/}
                {/*    style={{ display: state ? "none" : "block" }}*/}
                {/*    */}
                {/*/>*/}
            </Placeholder>

            <Image
                onLoad={onImageLoaded}
                src={photo}

                className={"competition-photo"}
                style={{ display: state ? "block" : "none" }}
            />
            <div className={"competition-detail-section"}>
                <Header className={"competition-name"} as={"h3"}>
                    {name}
                </Header>
                    {/*<p className={'number'}>{number}</p>*/}
                <p className={"competition-details"}>{details}</p>
                <div style={{textAlign:'center'}}>
                    {/*<a href={rules} target={"_blank"}>*/}
                    {btnVisibilty && (!btnVisibilty[0]) ? null : (
                            <><Button onClick={()=>{
                                setContent(modal);
                                setShow(true);
                            }} className='rulesButton'>
                                LEARN MORE
                            </Button>
                        <br/></>
                    )}
                    {/*</a>*/}
                    {
                        btnVisibilty && ( !btnVisibilty[1]) ? null : (
                            <a style={{display: submit ? "block" : "none"}} href={submit} target={"_blank"}>
                                <Button className='rulesButton'>
                                    {submitAlt ? submitAlt : 'SUBMIT' }
                                </Button>
                            </a>
                        )
                    }
                </div>
            </div>
        </div>
    );
}
